import IconClose from "@assets/icons/IconClose";

export const BrcPhoneScreenHeader = ({ details, style }) => {
  return (
    <div>
      <div
        className=" text-white py-4 flex justify-between items-center"
        style={style}
      >
        <h1 className="text-2xl flex justify-center items-center w-full">
          <span className="text-color-gold font-bold pr-1">Partner</span> Brand
        </h1>
        <IconClose className="text-white" />
      </div>
      <div className="flex h-24">
        <div className="bg-sky-900 font-bold text-white flex-1 text-center  text-base py-8">
          No Annual Fee.
        </div>
        <div className="bg-white flex-1 text-black overflow-hidden px-2 w-full">
          {details}
        </div>
      </div>
    </div>
  );
};
